export function translatable<T = string | string[]>(value: T): T {
    return value;
}
